import Fade from "@mui/material/Fade";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Stack from "@mui/material/Stack";
import { useContext, useEffect, useState } from "react";
import useDidMountEffect from "../../components/400/useDidMountEffect";
import { Controller, useForm, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import {
  FormGroup,
  TextField,
  InputLabel,
  MenuItem,
  InputAdornment,
  OutlinedInput,
  FormControl,
  Button,
  Box,
  Select,
  Typography,
  FormControlLabel,
  FormLabel,
  Divider,
  FormHelperText,
  inputAdornmentClasses,
} from "@mui/material";

import {
  labelStyled,
  groupStyled,
  row,
  col,
  formGroupContainer,
  header,
  leftCol,
} from "../../components/400/styles";

import { useNavigate, NavLink, useLocation } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

const axios = require("axios");

// const api = axios.create({
//     baseURL: "http://localhost:5000/api/"
// })

const schema = yup.object().shape({
  semester_term: yup.string().required(),
  acad_year: yup.number().required(),
  batch_year: yup.string().required("Academic year required"),
  year: yup.string().required("year is required"),
  // admission_type : yup.number("invalid input").positive("invalid inpt").integer("invalid input").required("number of groups is required"),
  // program_type : yup.string().min(1,"invalid input,title is a character").max(1,"invalid input,title is alphabet"),
  department: yup.string().required(),
});

export default function UpdateBatch() {
  const [successOpen, setSuccessOpen] = useState(false);
  const api = useAxiosPrivate();
  const navigate = useNavigate();
  const location = useLocation();
  const [amount, setAmount] = useState([]);
  const [aYear, setAyear] = useState([]);
  const [semError, setSemError] = useState(false);
  // const {updateId} = useContext(RowContext)
  const updateId = location.state.updateId;

  const getBatchData = async () => {
    console.log(updateId);
    const result = await api.get(`getBatch/${updateId}`);
    console.log(result);
    setValue("try", result.data[0].department);
    setValue("batch_year", result.data[0].batch_year);
    setValue("year", result.data[0].year);
    setValue("admission_type", result.data[0].admission_type);
    setValue("program_type", result.data[0].program_type);
    // const semester = await api.get(
    //     `/getBatchSemester/${data.acad_year}/${data.semester_term}`
    //   );
    // setValue("semester_term",semester.data[0].semester_term)
  };

  const getSemester = async () => {
    const a = [];
    const sem = await api.get("/getSemester");
    sem.data.forEach((c) => {
      a.push(c.academic_year);
    });
    const ab = a.filter((item, index) => a.indexOf(item) === index);
    setAyear(ab);
  };

  const onSub = async (data) => {
    const semester = await api.get(
      `/getBatchSemester/${data.acad_year}/${data.semester_term}`
    );

    const dt = {
      department: data.department,
      batch_year: data.batch_year,
      admission_type: data.admission_type,
      year: data.year,
      program_type: data.program_type,
      semester_id: semester.data[0].id,
    };
    console.log(semester);
    if (semester.data.length > 0) {
      const result = await api.put(`updateBatch/${updateId}`, dt);
      if (result.status === 200) setSuccessOpen(true);
    } else if (semester.data.length === 0) {
      setSemError(true);
    }
  };

  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    control,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      admission_type: "regular",
      program_type: "Bsc",
      department: "123",
    },
    resolver: yupResolver(schema),
  });

  const getDepartment = async () => {
    const result = await api.get("/getOffice");
    setAmount(result.data);
  };

  useEffect(() => {
    getDepartment();
    getBatchData();
    getSemester();
  }, [""]);

  return (
    <div>
      <form width="100px" onSubmit={handleSubmit(onSub)}>
        <Box sx={header}>
          <Typography
            variant="span"
            sx={{
              fontSize: "1.14rem",
              fontWeight: "600",
              lineHeight: "23.2px",
              color: "primary.main",
              mb: 5,
              mt: 2,
            }}
          >
            update batch
          </Typography>
        </Box>
        <Box sx={formGroupContainer}>
          <Box sx={leftCol}>
            <Box sx={row}>
              <FormControl>
                <FormLabel sx={labelStyled}>academic year</FormLabel>
                <Controller
                  control={control}
                  name="try"
                  render={({ field }) => (
                    <>
                      <Select
                        {...register("acad_year")}
                        error={errors.acad_year ? true : false}
                      >
                        {aYear.map((d) => {
                          return (
                            <MenuItem key={d} value={d}>
                              {d}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </>
                  )}
                />
                <FormHelperText>
                  {errors.acad_year && "academic year is required"}
                </FormHelperText>
              </FormControl>

              <FormControl>
                <FormLabel sx={labelStyled}>semester term</FormLabel>
                <Controller
                  control={control}
                  name="semester_term"
                  render={({ field }) => (
                    <>
                      <Select
                        {...field}
                        error={errors.semester_term ? true : false}
                      >
                        <MenuItem value="I">I</MenuItem>
                        <MenuItem value="II">II</MenuItem>
                        <MenuItem value="summer">summer</MenuItem>
                      </Select>
                    </>
                  )}
                />
                <FormHelperText>
                  {errors.semester_term && "semester term required"}
                </FormHelperText>
              </FormControl>
            </Box>
            <FormControl>
              <FormLabel sx={labelStyled}>department</FormLabel>
              <Controller
                control={control}
                name="try"
                render={({ field }) => (
                  <>
                    <Select
                      name="department"
                      {...register("department")}
                      error={errors.department ? true : false}
                    >
                      {amount.map((d) => {
                        return (
                          <MenuItem key={d.id} value={d.id}>
                            {d.name}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </>
                )}
              />
              <FormHelperText>
                {errors.department && "department is required"}
              </FormHelperText>
            </FormControl>

            <FormControl sx={groupStyled}>
              <FormLabel sx={labelStyled}>Batch Year</FormLabel>
              <TextField
                type="number"
                id="batch_year"
                name="batch_year"
                {...register("batch_year")}
                fullWidth
                error={errors.batch_year ? true : false}
              />
              <FormHelperText>{errors.batch_year?.message}</FormHelperText>
            </FormControl>

            <FormControl sx={groupStyled}>
              <FormLabel sx={labelStyled}>Year</FormLabel>
              <TextField
                type="number"
                id="year"
                name="year"
                {...register("year")}
                fullWidth
                error={errors.year ? true : false}
              />
              <FormHelperText>{errors.year?.message}</FormHelperText>
            </FormControl>

            <FormControl>
              <FormLabel sx={labelStyled}>Program Type</FormLabel>
              <Controller
                control={control}
                name="program_type"
                render={({ field }) => (
                  <>
                    <Select {...field}>
                      <MenuItem value="Bsc">Bsc</MenuItem>
                      <MenuItem value="Msc">Masters</MenuItem>
                      <MenuItem value="phd">Phd</MenuItem>
                    </Select>
                  </>
                )}
              />
            </FormControl>
            <FormControl>
              <FormLabel sx={labelStyled}>Admission Type</FormLabel>
              <Controller
                control={control}
                name="admission_type"
                render={({ field }) => (
                  <>
                    <Select {...field}>
                      <MenuItem value="regular">regular</MenuItem>
                      <MenuItem value="extension">extension</MenuItem>
                    </Select>
                  </>
                )}
              />
            </FormControl>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: "1.8rem",
            justifyContent: "flex-end",
            width: "100%",
          }}
        >
          <Button
            variant="outlined"
            sx={{
              backgroundColor: "teritiary.lighter1",
              "&:hover": {
                backgroundColor: "teritiary.main",
              },
            }}
            onClick={() => {
              navigate("/batch_management");
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "secondary.lighter1",
              "&:hover": {
                backgroundColor: "secondary.main",
              },
            }}
            type="submit"
            onClick={() => {
              console.log("clicked");
            }}
          >
            Update
          </Button>
        </Box>
      </form>
      <Fade
        in={semError}
        timeout={{ enter: 1000, exit: 1000 }}
        addEndListener={() => {
          setTimeout(() => {
            setSemError(false);
          }, 4000);
        }}
      >
        <Alert severity="error">
          <AlertTitle>Error</AlertTitle>
          semester term not found
        </Alert>
      </Fade>
      <Fade
        in={successOpen}
        timeout={{ enter: 1000, exit: 1000 }}
        addEndListener={() => {
          setTimeout(() => {
            setSuccessOpen(false);
            // navigate("/batch_management");
          }, 4000);
        }}
      >
        <Alert>
          <AlertTitle>Success</AlertTitle>
          semester successfully updated
        </Alert>
      </Fade>
    </div>
  );
}
